import React from 'react';
import { Button, Chip, Paper } from '@material-ui/core';
import StepClientID from './Steps/StepClientID';
import StepTokenGeneration from './Steps/StepTokenGeneration';
import StepPrerequisites from './Steps/StepPrerequisites';
import StepRequestForm from './Steps/StepRequestForm';
import StepValidation from './Steps/StepValidation';
import { CAT_YELLOW } from './utils/styles';
import { ONBOARDING_STEPS } from './utils/constants';


export default function StepDetailPanel({
  stepId,
  classes,
  onPrev,
  onNext,
  isFirst,
  isLast,
}: {
  stepId: number;
  classes: any;
  onPrev: () => void;
  onNext: () => void;
  isFirst: boolean;
  isLast: boolean;
}) {
  const step = ONBOARDING_STEPS[stepId - 1];

  const renderContent = () => {
    switch (stepId) {
      case 1: return <StepClientID classes={classes} />;
      case 2: return <StepTokenGeneration classes={classes} />;
      case 3: return <StepPrerequisites classes={classes} />;
      case 4: return <StepRequestForm classes={classes} />;
      case 5: return <StepValidation classes={classes} />;
      default: return null;
    }
  };

  return (
    <Paper className={classes.stepPanel} elevation={0}>
      <div className={classes.stepPanelHeader}>
        <div className={classes.stepPanelTitle}>
          <span className={classes.stepPanelTitleIcon}>{step.icon}</span>
          <span>Step {stepId}: {step.title}</span>
        </div>
        <Chip
          label={`${stepId} of ${ONBOARDING_STEPS.length}`}
          size="small"
          style={{ background: `${CAT_YELLOW}30`, color: CAT_YELLOW, fontWeight: 700, border: `1px solid ${CAT_YELLOW}50` }}
        />
      </div>
      <div className={classes.stepPanelBody}>
        {renderContent()}
        <div className={classes.stepNavBar}>
          <Button
            className={classes.stepNavBtnOutline}
            onClick={onPrev}
            disabled={isFirst}
          >
            ← Previous
          </Button>
          {!isLast ? (
            <Button className={classes.stepNavBtn} onClick={onNext}>
              Next Step →
            </Button>
          ) : (
            <Button
              className={classes.stepNavBtn}
              onClick={onPrev}
              style={{ background: '#9E9E9E', color: '#FFF' }}
              disabled
            >
              All Steps Complete ✓
            </Button>
          )}
        </div>
      </div>
    </Paper>
  );
}
